export const authTags = {
  USER: 'user',
};
